import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListBullets = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "list-bullets",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Oval_237",
				d: "M1.23502 2.32941C1.8769 2.32941 2.39972 1.80659 2.39972 1.16471C2.39972 0.522824 1.8769 0 1.23502 0C0.593136 0 0.0703125 0.522824 0.0703125 1.16471C0.0703125 1.80659 0.593136 2.32941 1.23502 2.32941Z",
				fill: "#3C59F6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Oval_238",
				d: "M3.23502 6.98566C3.8769 6.98566 4.39972 6.46284 4.39972 5.82096C4.39972 5.17907 3.8769 4.65625 3.23502 4.65625C2.59314 4.65625 2.07031 5.17907 2.07031 5.82096C2.07031 6.46284 2.59314 6.98566 3.23502 6.98566Z",
				fill: "#3C59F6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Oval_239",
				d: "M1.23502 11.6458C1.8769 11.6458 2.39972 11.123 2.39972 10.4811C2.39972 9.83923 1.8769 9.31641 1.23502 9.31641C0.593136 9.31641 0.0703125 9.83923 0.0703125 10.4811C0.0703125 11.123 0.593136 11.6458 1.23502 11.6458Z",
				fill: "#3C59F6"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.49609 0.90625C4.49609 0.492036 4.83188 0.15625 5.24609 0.15625H11.0696C11.4838 0.15625 11.8196 0.492036 11.8196 0.90625C11.8196 1.32046 11.4838 1.65625 11.0696 1.65625H5.24609C4.83188 1.65625 4.49609 1.32046 4.49609 0.90625ZM6.49609 5.56406C6.49609 5.14985 6.83188 4.81406 7.24609 4.81406H13.0696C13.4838 4.81406 13.8196 5.14985 13.8196 5.56406C13.8196 5.97828 13.4838 6.31406 13.0696 6.31406H7.24609C6.83188 6.31406 6.49609 5.97828 6.49609 5.56406ZM4.49609 10.2219C4.49609 9.80766 4.83188 9.47188 5.24609 9.47188H11.0696C11.4838 9.47188 11.8196 9.80766 11.8196 10.2219C11.8196 10.6361 11.4838 10.9719 11.0696 10.9719H5.24609C4.83188 10.9719 4.49609 10.6361 4.49609 10.2219Z",
				fill: "#3C59F6"
			})
		]
	})
});
export default SvgListBullets;
